import AxiosService from '../../../gateway/rest/AxiosService'

class TestdataInDbRestService {
  inDb = '/testdata/indb'
  policies = this.inDb + '/policies'
  configs = this.inDb + '/configs'
  jobs = this.inDb + '/jobs'
  tokenizerConfigs = this.policies + '/tokenizerconfigs'

  getAllConfigs(): Promise<any> {
    return AxiosService.get(this.configs)
  }

  createConfig(config: any): Promise<any> {
    return AxiosService.post(this.configs, config)
  }

  getConfigById(id: number): Promise<any> {
    return AxiosService.get(this.configs + '/' + id)
  }

  updateConfig(config: any): Promise<any> {
    return AxiosService.put(this.configs, config)
  }

  deleteConfig(id: number): Promise<any> {
    return AxiosService.delete(this.configs + '/' + id)
  }

  getAllJobs(): Promise<any> {
    return AxiosService.get(this.jobs)
  }

  createJob(job: any): Promise<any> {
    return AxiosService.post(this.jobs, job)
  }

  getJobById(id: number): Promise<any> {
    return AxiosService.get(this.jobs + '/' + id)
  }

  deleteJob(id: number): Promise<any> {
    return AxiosService.delete(this.jobs + '/' + id)
  }

  startJob(id: number): Promise<any> {
    return AxiosService.post(this.jobs + '/' + id + '/start')
  }

  assignPoliciesToJob(jobId: number, policyIds: number[]): Promise<any> {
    return AxiosService.put(this.jobs + '/' + jobId + '/policies', policyIds)
  }

  getAllPolicies(): Promise<any> {
    return AxiosService.get(this.policies)
  }

  createPolicy(policy: any): Promise<any> {
    return AxiosService.post(this.policies, policy)
  }

  getPolicyById(id: number): Promise<any> {
    return AxiosService.get(this.policies + '/' + id)
  }

  updatePolicy(policy: any): Promise<any> {
    return AxiosService.put(this.policies, policy)
  }

  copyPolicy(policy: any): Promise<any> {
    return AxiosService.put(this.policies + '/' + policy.id + '/' + policy.configName)
  }

  generateRows(config: any): Promise<any> {
    return AxiosService.post(`${this.policies}/${config.id}/generate?totalLines=${config.totalLines}`)
  }

  deletePolicy(id: number): Promise<any> {
    return AxiosService.delete(this.policies + '/' + id)
  }

  getTokenizerConfigsOfPolicy(id: number): Promise<any> {
    return AxiosService.get(this.policies + '/' + id + '/tokenizerconfigs')
  }

  addTokenizerConfig(config: any): Promise<any> {
    return AxiosService.post(this.policies + '/' + config.configId + '/tokenizerconfigs', config)
  }

  updateTokenizerConfig(config: any): Promise<any> {
    return AxiosService.put(this.tokenizerConfigs, config)
  }

  deleteTokenizerConfig(id: number): Promise<any> {
    return AxiosService.delete(this.tokenizerConfigs + '/' + id)
  }

  populatePolicyTable(id: number): Promise<any> {
    return AxiosService.post(this.policies + '/' + id + '/tokenizerconfigs/populate')
  }
}

export default new TestdataInDbRestService()
